"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPanelWrapper = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
const StyledPanelWrapper = _styled.default.aside`
    border-radius: var(--sds--panel--border-radius, ${_designTokens.border.radius40});
    background: ${(0, _designTokensReact.color)("color--background--surfaces--work")};
    height: 100%;
    width: 100%;
    min-width: var(--sds--panel--min--width, 348px);
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
`;
exports.StyledPanelWrapper = StyledPanelWrapper;
//# sourceMappingURL=StyledPanelComponents.js.map